import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable, of } from 'rxjs';
import {
  CreateTwikeyInviteRequestV1,
  CreateTwikeyInviteResponseV1,
  GetPadVerifiedStatusRequestV1,
  GetPadVerifiedStatusResponseV1,
} from '../models';
import { HttpClient } from '@angular/common/http';
import { PadAgreementService } from './pad-agreement.service';
import { CompleteTwikeyInviteRequestV1 } from '../models/twikey';

export class PadAgreementPaymentLinksService extends PadAgreementService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  getPadVerifiedStatus(
    tenantId: string,
    payload: GetPadVerifiedStatusRequestV1,
  ): Observable<GetPadVerifiedStatusResponseV1> {
    return this.httpClient.post<GetPadVerifiedStatusResponseV1>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment-links/twikey/payment-accounts-pad/verify`,
      payload,
    );
  }

  createTwikeyInvite(
    tenantId: string,
    payload: CreateTwikeyInviteRequestV1,
  ): Observable<CreateTwikeyInviteResponseV1> {
    return this.httpClient.post<CreateTwikeyInviteResponseV1>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment-links/twikey/invite`,
      payload,
    );
  }

  completeTwikeyInvite(
    tenantId: string,
    payload: CompleteTwikeyInviteRequestV1,
  ): Observable<void> {
    return this.httpClient.put<void>(
      `${this.baseUrl}/v1/tenants/${tenantId}/payment-links/twikey/invite/complete`,
      payload,
    );
  }
}
